<template>
  <section class="p-5">
    <b-loading :active.sync="loading" />
    <div class="w-full flex justify-between items-center">
      <Lynx-Title text="Espelho Nota Fiscal" />

      <!-- <Lynx-Button @click.native="voltar()">Voltar</Lynx-Button> -->
    </div>
    <!-- <b-field grouped group-multiline> -->
    <!-- <div class="control">
        <b-switch
          v-model="position"
          true-value="is-right"
          false-value="is-left"
        >
          Right position
        </b-switch>
      </div> -->
    <!-- <b-field label="Size" label-position="on-border">
        <b-select v-model="size" placeholder="Size">
          <option :value="null">Default</option>
          <option value="is-small">Small</option>
          <option value="is-medium">Medium</option>
          <option value="is-large">Large</option>
        </b-select>
      </b-field> -->
    <!-- <b-field label="Label position" label-position="on-border">
        <b-select v-model="labelPosition">
          <option value="bottom">Bottom</option>
          <option value="right">Right</option>
          <option value="left">Left</option>
        </b-select>
      </b-field>
    </b-field> -->
    <Lynx-Title text="Tomador" />
    <form @submit.prevent="confirm(lista_campos == '' ? 'cria' : 'edita')">
      <div>
        <div class="flex justify-between items-center gap-2">
          <!-- Campo de Data de Emissão -->
          <label class="flex flex-col w-2/4 pb-8">
            <Lynx-Label label="Data de Emissão" />
            <Lynx-Input
              :disabled="admin"
              type="date"
              v-model="form.data_emissao"
            />
          </label>
          <b-icon
            @click.native="copyDate(form.data_emissao)"
            icon="content-copy"
            size="is-small"
          ></b-icon>

          <!-- Campo de Competência -->
          <!-- <label class="flex flex-col w-2/4 pb-8">
            <Lynx-Label label="Data de Competencia" />
            <b-datepicker
              :disabled="admin"
              placeholder="Informe uma data de competencia"
              icon="calendar-today"
              type="month"
              :month-names="monthNames"
              :day-names="dayNames"
              v-model="form.data_competencia"
            />
          </label>
          <b-icon
            @click.native="copyDate(form.data_competencia)"
            icon="content-copy"
            size="is-small"
          ></b-icon> -->

          <!-- Campo de Número da Nota Fiscal -->
          <label class="flex flex-col w-2/4 pb-8">
            <Lynx-Label label="Número da Nota Fiscal" />
            <Lynx-Input
              :disabled="admin"
              type="text"
              v-model="form.numero_nota_fiscal"
            />
          </label>

          <b-icon
            @click.native="copyText(form.numero_nota_fiscal)"
            icon="content-copy"
            size="is-small"
          ></b-icon>
        </div>

        <div class="flex justify-between items-center gap-2">
          <label class="flex flex-col w-2/4 pb-8">
            <Lynx-Label label="CNPJ/CPF Tomador" />

            <Lynx-Input
              placeholder="Digite cpf ou cnpj"
              v-model="form.cpf_cnpj"
            />
          </label>
          <b-icon
            @click.native="copyText(form.cpf_cnpj)"
            icon="content-copy"
            size="is-small"
          ></b-icon>

          <label class="flex flex-col w-1/8 pb-1">
            <v-btn color="primary" @click.native="pegarTomador()">
              <v-icon>mdi-account-search</v-icon>
            </v-btn>
          </label>

          <label class="flex flex-col w-1/2 pb-8">
            <Lynx-Label label="Email do Notificavel" />

            <Lynx-Input
              :disabled="tomador == {}"
              placeholder="Digite Email notificavel"
              v-model="form.email_notificavel"
            />
            <!-- <Lynx-Input
              placeholder="Digite email do Tomador"
              v-model="form.email_financeiro"
            /> -->
          </label>
          <b-icon
            @click.native="copyText(form.email_notificavel)"
            icon="content-copy"
            size="is-small"
          ></b-icon>
        </div>
        <div class="flex justify-between items-center gap-2">
          <label class="flex flex-col w-full pb-8">
            <Lynx-Label label="Razão Social" />

            <Lynx-Input
              :disabled="tomador == {}"
              placeholder="Digite a razão social"
              v-model="form.razao_social"
            />
          </label>
          <b-icon
            @click.native="copyText(form.email_notificavel)"
            icon="content-copy"
            size="is-small"
          ></b-icon>

          <label v-if="isCollapsed.tomador" class="flex flex-col w-2/4 pb-8">
            <Lynx-Label label="Celular" />

            <Lynx-Input
              disabled
              placeholder="Digite o celular"
              v-model="form.celular"
            />
          </label>
          <b-icon
            v-if="isCollapsed.tomador"
            @click.native="copyText(form.email_notificavel)"
            icon="content-copy"
            size="is-small"
          ></b-icon>
        </div>
        <b-collapse class="mb-3" :open.sync="isCollapsed.tomador">
          <div slot="trigger" class="button is-primary">
            {{ !isCollapsed.tomador ? "Expandir" : "Recolher" }}
          </div>
          <div>
            <div class="flex justify-between items-center gap-2">
              <label class="flex flex-col w-1/4 pb-8">
                <Lynx-Label label="CEP" />

                <Lynx-Input
                  disabled
                  placeholder="Digite o cep"
                  v-model="form.cep"
                />
              </label>
              <b-icon
                @click.native="copyText(form.cep)"
                icon="content-copy"
                size="is-small"
              ></b-icon>

              <label class="flex flex-col w-full pb-8">
                <Lynx-Label label="Endereço" />

                <Lynx-Input
                  disabled
                  placeholder="Digite o endereço"
                  v-model="form.endereco"
                />
              </label>
              <b-icon
                @click.native="copyText(form.endereco)"
                icon="content-copy"
                size="is-small"
              ></b-icon>

              <label class="flex flex-col w-1/4 pb-8">
                <Lynx-Label label="Número" />

                <Lynx-Input
                  disabled
                  placeholder="Digite o número"
                  v-model="form.numero"
                />
              </label>
              <b-icon
                @click.native="copyText(form.endereco)"
                icon="content-copy"
                size="is-small"
              ></b-icon>
            </div>
            <div class="flex justify-between items-center gap-2">
              <label class="flex flex-col w-full pb-8">
                <Lynx-Label label="Complemento" />

                <Lynx-Input
                  disabled
                  placeholder="Digite o complemento"
                  v-model="form.complemento"
                />
              </label>
              <b-icon
                @click.native="copyText(form.complemento)"
                icon="content-copy"
                size="is-small"
              ></b-icon>

              <label class="flex flex-col w-1/3 pb-8">
                <Lynx-Label label="Estados" />

                <Treeselect
                  disabled
                  :options="lista_estados"
                  placeholder="Selecione o estado"
                  v-model="form.estado_id"
                />
              </label>

              <label class="flex flex-col w-1/3 pb-8">
                <Lynx-Label label="Cidades" />

                <Treeselect
                  disabled
                  :options="lista_cidades"
                  placeholder="Selecione a cidae"
                  v-model="form.cidade_id"
                />
              </label>
            </div>

            <div class="flex justify-between items-start gap-2">
              <label class="flex flex-col w-1/2 pb-8">
                <Lynx-Label label="Documentos necessários" />

                <!-- <h2>Documentos Necessários</h2> -->
                <ul v-if="lista_campos.tomadores_id && documentos_necessarios">
                  <li
                    v-for="(documento, index) in listaDocumentos"
                    :key="index"
                    v-show="documentos_necessarios.includes(documento.id)"
                  >
                    <input
                      type="checkbox"
                      :id="`documento_${documento.id}`"
                      v-model="documento.checked"
                    />
                    <label class="ml-1" :for="`documento_${documento.id}`">{{
                      documento.label
                    }}</label>
                  </li>
                </ul>
              </label>
            </div>
          </div>
        </b-collapse>

        <div class="flex justify-between items-start gap-2">
          <label class="flex flex-col w-1/2 pb-8">
            <Lynx-Label label="Observação Tomador" />

            <vue-editor
              disabled
              class="bg-white"
              v-model="form.observacao"
            ></vue-editor>
          </label>
          <b-icon
            @click.native="copyText(form.observacao)"
            icon="content-copy"
            size="is-small"
          ></b-icon>

          <label class="flex flex-col w-1/2 pb-8">
            <Lynx-Label label="Descrição Nota Fiscal" />

            <vue-editor
              disabled
              class="bg-white"
              v-model="form.descricao_notafiscal"
            ></vue-editor>
          </label>
          <b-icon
            @click.native="copyText(form.descricao_notafiscal)"
            icon="content-copy"
            size="is-small"
          ></b-icon>
        </div>
      </div>

      <hr style="border: 2px dashed black" />

      <Lynx-Title class="mt-3" text="Prestador de serviço" />

      <div class="flex items-start gap-2">
        <!-- <label class="flex flex-col w-3/4 pb-8">
              <Lynx-Label label="Descrição do Serviço" />

              <vue-editor
                :disabled="admin"
                class="bg-white"
                v-model="servico.descricao"
              ></vue-editor>
            </label> -->
        <!-- <b-icon
              @click.native="copyText(servico.descricao)"
              icon="content-copy"
              size="is-small"
            ></b-icon> -->

        <div class="w-2/6">
          <Lynx-Label label="Dados Bancários" />

          <treeselect
            :multiple="true"
            :options="contas_socio"
            placeholder="Selecione o socio..."
            v-model="servico.responsaveis_conta_bancaria"
            @input="getContasResponsavelBancarias()"
          />

          <v-card
            v-for="(conta_bank, index) in servico.contasBancarias"
            :key="index"
            elevation="10"
            class="p-3"
          >
            <contaBancaria :contaBancaria="conta_bank"></contaBancaria>
          </v-card>
        </div>

        <div class="w-full items-center gap-2">
          <div class="flex w-full items-center gap-2">
            <label class="w-1/2 pb-8">
              <Lynx-Label label="ID" />

              <Lynx-Input disabled placeholder="Id" v-model="servico.id" />
            </label>
            <label class="flex flex-col w-1/2 pb-8">
              <Lynx-Label disabled label="CNPJ/ID" />

              <Lynx-Input
                disabled
                placeholder="Digite cpf ou cnpj"
                v-model="servico.cpf_cnpj"
              />
            </label>
            <b-icon
              @click.native="copyText(servico.cpf_cnpj)"
              icon="content-copy"
              size="is-small"
            ></b-icon>

            <label class="flex flex-col w-1/8 pb-1">
              <v-btn color="primary" @click.native="pegarCliente()">
                <v-icon>mdi-account-search</v-icon>
              </v-btn>
            </label>
          </div>

          <div class="flex w-full items-center gap-2">
            <label class="flex flex-col w-1/2 pb-8">
              <Lynx-Label label="Inscrição Municipal" />

              <Lynx-Input
                disabled
                placeholder="Inscrição Municipal"
                v-model="servico.inscricao_municipal"
              />
            </label>
            <b-icon
              @click.native="copyText(servico.inscricao_municipal)"
              icon="content-copy"
              size="is-small"
            ></b-icon>

            <label class="flex flex-col w-1/2 pb-8">
              <Lynx-Label label="Regime Tributário" />

              <Lynx-Input
                disabled
                placeholder="Regime Tributário"
                v-model="servico.regime_tributario"
              />
            </label>
            <b-icon
              @click.native="copyText(servico.regime_tributario)"
              icon="content-copy"
              size="is-small"
            ></b-icon>
          </div>
        </div>
      </div>
      <div class="mt-5">
        <div v-for="(socio, index) in form_espelho.socios" :key="index">
          <div class="mb-1 items-start flex gap-2">
            <label class="flex flex-col w-5/6">
              <Lynx-Label label="Socio" />
              <Lynx-Input disabled :value="socio.socio" />
            </label>
            <label class="flex flex-col w-1/6">
              <Lynx-Label label="Valor" />
              <InputMoney required v-model="socio.valor" />
            </label>
          </div>
        </div>

        <div class="flex justify-between items-center gap-2">
          <label class="flex flex-col w-full pb-8">
            <Lynx-Label label="Razão Social" />

            <Lynx-Input
              disabled
              placeholder="Digite a razão social"
              v-model="servico.razao_social"
            />
          </label>
          <b-icon
            @click.native="copyText(servico.razao_social)"
            icon="content-copy"
            size="is-small"
          ></b-icon>

          <label class="flex flex-col w-2/4 pb-8">
            <Lynx-Label label="Celular" />

            <Lynx-Input
              :disabled="admin"
              placeholder="Digite o celular"
              v-model="servico.celular"
            />
          </label>
          <b-icon
            @click.native="copyText(servico.celular)"
            icon="content-copy"
            size="is-small"
          ></b-icon>
        </div>

        <b-collapse class="mb-2" :open.sync="isCollapsed.servico">
          <div slot="trigger" class="button is-primary">
            {{ !isCollapsed.servico ? "Expandir" : "Recolher" }}
          </div>
          <div>
            <!-- Conteúdo que será colapsado ou expandido -->
            <div class="flex justify-between items-center gap-2">
              <label class="flex flex-col w-1/4 pb-8">
                <Lynx-Label label="CEP" />

                <Lynx-Input
                  disabled
                  placeholder="Digite o cep"
                  v-model="servico.cep"
                />
              </label>
              <b-icon
                @click.native="copyText(servico.cep)"
                icon="content-copy"
                size="is-small"
              ></b-icon>

              <label class="flex flex-col w-full pb-8">
                <Lynx-Label label="Endereço" />

                <Lynx-Input
                  disabled
                  placeholder="Digite o endereço"
                  v-model="servico.endereco"
                />
              </label>
              <b-icon
                @click.native="copyText(servico.endereco)"
                icon="content-copy"
                size="is-small"
              ></b-icon>

              <label class="flex flex-col w-1/4 pb-8">
                <Lynx-Label label="Número" />

                <Lynx-Input
                  disabled
                  placeholder="Digite o número"
                  v-model="servico.numero"
                />
              </label>
              <b-icon
                @click.native="copyText(servico.numero)"
                icon="content-copy"
                size="is-small"
              ></b-icon>
            </div>
            <div class="flex justify-between items-center gap-2">
              <label class="flex flex-col w-1/2 pb-8">
                <Lynx-Label label="Complemento" />

                <Lynx-Input
                  disabled
                  placeholder="Digite o complemento"
                  v-model="servico.complemento"
                />
              </label>
              <b-icon
                @click.native="copyText(servico.complemento)"
                icon="content-copy"
                size="is-small"
              ></b-icon>

              <label class="flex flex-col w-1/2 pb-8">
                <Lynx-Label label="Email" />

                <Lynx-Input
                  :disabled="admin"
                  placeholder="Digite Email"
                  v-model="servico.email"
                />
              </label>
              <b-icon
                @click.native="copyText(servico.email)"
                icon="content-copy"
                size="is-small"
              ></b-icon>

              <label class="flex flex-col w-1/3 pb-8">
                <Lynx-Label label="Estado" />
                <Lynx-Input
                  disabled
                  placeholder="Estado"
                  v-model="servico.estado"
                />
              </label>
              <b-icon
                @click.native="copyText(servico.estado)"
                icon="content-copy"
                size="is-small"
              ></b-icon>

              <label class="flex flex-col w-1/3 pb-8">
                <Lynx-Label label="Cidade" />

                <Lynx-Input
                  disabled
                  placeholder="Cidade"
                  v-model="servico.cidade"
                />
              </label>
              <b-icon
                @click.native="copyText(servico.cidade)"
                icon="content-copy"
                size="is-small"
              ></b-icon>
            </div>

            <div class="flex justify-between items-center gap-2">
              <label class="flex flex-col w-full pb-8">
                <Lynx-Label label="item" />

                <Treeselect
                  :disabled="admin"
                  :multiple="false"
                  :options="lista_item"
                  placeholder="Selecione items"
                  v-model="servico.item"
                />
              </label>
              <label class="flex flex-col w-full pb-8">
                <Lynx-Label label="Cod. Tributação" />

                <Lynx-Input
                  :disabled="admin"
                  placeholder="Codigo tributação"
                  v-model="servico.cod_tributacao"
                />
              </label>
            </div>
          </div>
        </b-collapse>
        <div class="flex justify-between items-center gap-2">
          <label class="flex flex-col w-full pb-8">
            <Lynx-Label label="Valor Serviço" />
            <InputMoney
              :disabled="admin"
              placeholder="digite o Valor Serviço"
              v-model="servico.valor_servico"
            />
          </label>
          <b-icon
            @click.native="copyValor(servico.valor_servico)"
            icon="content-copy"
            size="is-small"
          ></b-icon>

          <label class="flex flex-col w-full pb-8">
            <Lynx-Label label="Valor Dedução " />
            <InputMoney
              :disabled="admin"
              placeholder="Digite o Valor Dedução"
              v-model="servico.valor_deducao"
            />
          </label>
          <b-icon
            @click.native="copyValor(servico.valor_deducao)"
            icon="content-copy"
            size="is-small"
          ></b-icon>

          <label class="flex flex-col w-full pb-8">
            <Lynx-Label label="Base do Calculo" />
            <InputMoney
              disabled
              placeholder="Digite a Base do Calculo"
              v-model="servico.base_calculo"
            />
          </label>
          <b-icon
            @click.native="copyValor(servico.base_calculo)"
            icon="content-copy"
            size="is-small"
          ></b-icon>
        </div>

        <!-- <p v-if="servico.contaBancaria != null" class="font-bold">
            CPF/CNPJ:
            <span
              class="font-normal"
            
            >{{ servico.contaBancaria.cpf_cnpj }}</span>
          </p> -->
      </div>

      <div>
        <div
          class="mb-1 grid grid-cols-2 items-start"
          v-if="
            (servico.base_calculo > 215.06 &&
              servico.regime_tributario == 'Lucro Presumido') ||
            servico.regime_tributario == 'presumido com equiparação'
          "
        >
          <label class=" ">
            <Lynx-Label label="Descricao" />

            <b-select
              :required="
                servico.regime_tributario == 'Lucro Presumido' ||
                servico.regime_tributario == 'presumido com equiparação'
              "
              class="w-2/3"
              v-model="simulador"
            >
              <option :value="null" disabled selected>
                Selecione o simulador
              </option>
              <option value="1">Orgão Publico IR 1,2%</option>
              <option value="2">Orgão Publico IR 1,5%</option>
              <option value="3">Orgão Público IR 4,8%</option>
              <option value="4">Presumido</option>
              <option value="5">Presumido com IR 1,2%</option>
              <option value="6">Presumido com IR 4,8%</option>
              <option value="7">Nao possui retencao</option>
            </b-select>
          </label>
          <div>
            <table v-if="simulador" style="font-size: small">
              <thead>
                <tr>
                  <th>BASE DE CÁLCULO</th>
                  <th></th>
                  <th>R$ {{ this.servico.base_calculo | money }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in tabela[simulador]" :key="index">
                  <td>{{ item.descricao }}</td>
                  <td>{{ item.porcentagem }}%</td>
                  <td>R$ {{ calcularImposto(item).replace(".", ",") }}</td>
                </tr>

                <tr>
                  <td>Valor Líquido</td>
                  <td></td>
                  <td>R$ {{ calcularTotalImpostos().replace(".", ",") }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <Input-File class="mb-4" text="Adicionar Arquivo" ref="fileInput" />
        <div class="w-1/4">
          <label class=" ">
            <Lynx-Label label="Descricao" />

            <b-select v-model="form_espelho.descricao">
              <option :value="null" disabled selected>
                Selecione a descrição
              </option>
              <option value="Ativa">Ativa</option>
              <option value="Processo de Cancelamento">
                Processo de Cancelamento
              </option>
            </b-select>
          </label>
        </div>
        <div style="padding-bottom: 50px">
          <Lynx-Button
            :disabled="admin"
            style="color: white; float: right"
            type="submit"
            class="mt-4"
            >{{ lista_campos == "" ? "Criar" : "Atualizar" }}</Lynx-Button
          >
        </div>
      </div>
    </form>
  </section>
</template>
<script>
import InputFile from "@/components/helpers/InputFile";

import { empresasSociosRequest } from "@/services/requests/empresas";
import Treeselect from "@riophae/vue-treeselect";
import LynxTextarea from "@/components/helpers/Textarea";
import InputMoney from "@/components/helpers/InputMoney";
import {
  indexEstadosRequest,
  showEstadosRequest,
} from "@/services/requests/estados";
import { searchEmpresasServicoRequest } from "@/services/requests/empresas";
import contaBancaria from "./contaBancaria";
import { formatEnToBr } from "@/utils/momentHelpers";
import { dayNames, monthNames } from "@/utils/utils";
import moment from "moment";
import { hasRole, hasPermission } from "@/utils/can";
import { mapGetters } from "vuex";
import { contasBancariasRequest } from "@/services/requests/contasBancarias";

export default {
  components: {
    Treeselect,
    LynxTextarea,
    InputMoney,
    contaBancaria,
    InputFile,
  },

  data() {
    return {
      labelPosition: "bottom",
      position: null,
      isCollapsed: { servico: false, tomador: false },
      loading: false,
      size: "is-medium",
      estados: [],
      cidades: [],
      socios: [],
      contas_socio: [],
      contasBancarias: [],
      dayNames,
      monthNames,
      servico: {
        inscricao_municipal: null,
        razao_social: "",
        regime_tributario: "",
        celular: null,
        email: "",
        cep: null,
        endereco: "",
        numero: null,
        complemento: "",
        contaBancaria: null,
        cidade: null,
        estado: null,
        cpf_cnpj: "",
        simulador: null,
        item: null,
        cod_tributacao: null,
        descricao: null,
        valor_servico: 0.0,
        valor_deducao: 0.0,
        base_calculo: 0.0,
        contasBancarias: [],
      },
      form: {
        razao_social: "",
        celular: "",
        email_notificavel: "",
        cep: null,
        endereco: "",
        numero: "",
        complemento: "",
        cidade_id: null,
        estado_id: null,
        documentos_necessarios: null,
        cpf_cnpj: null,
        observacao: "",

        data_competencia: new Date(),
        data_emissao: new Date(),
        numero_nota_fiscal: null,
      },
      form_espelho: {
        tomadores_id: null,
        empresa_id: null,
        celular: "",
        email: "",
        servico: null,
        tomador: null,
        socios: [],
        simulador: null,
        simulacao: null,

        descricao: null,
      },

      documentos_necessarios: null,
      simulador: null,
      tabela: {
        1: [
          { descricao: "PIS", porcentagem: 0 },
          { descricao: "COFINS", porcentagem: 0 },
          { descricao: "CSLL", porcentagem: 0 },
          { descricao: "IR", porcentagem: 1.2 },
        ],
        2: [
          { descricao: "PIS", porcentagem: 0 },
          { descricao: "COFINS", porcentagem: 0 },
          { descricao: "CSLL", porcentagem: 0 },
          { descricao: "IR", porcentagem: 1.5 },
        ],
        3: [
          { descricao: "PIS", porcentagem: 0 },
          { descricao: "COFINS", porcentagem: 0 },
          { descricao: "CSLL", porcentagem: 0 },
          { descricao: "IR", porcentagem: 4.8 },
        ],
        4: [
          { descricao: "PIS", porcentagem: 0.65 },
          { descricao: "COFINS", porcentagem: 3 },
          { descricao: "CSLL", porcentagem: 1 },
          { descricao: "IR", porcentagem: 1.5 },
        ],
        5: [
          { descricao: "PIS", porcentagem: 0.65 },
          { descricao: "COFINS", porcentagem: 3 },
          { descricao: "CSLL", porcentagem: 1 },
          { descricao: "IR", porcentagem: 1.2 },
        ],
        6: [
          { descricao: "PIS", porcentagem: 0.65 },
          { descricao: "COFINS", porcentagem: 3 },
          { descricao: "CSLL", porcentagem: 1 },
          { descricao: "IR", porcentagem: 4.8 },
        ],
        7: [
          { descricao: "PIS", porcentagem: 0.0 },
          { descricao: "COFINS", porcentagem: 0.0 },
          { descricao: "CSLL", porcentagem: 0.0 },
          { descricao: "IR", porcentagem: 0.0 },
        ],
      },
      admin: false,
    };
  },
  created() {
    this.preenxer_campos();
  },
  filters: {
    formatEnToBr,
    money: (value) => {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  computed: {
    ...mapGetters(["getCompetenciaDate", "getEmpresa", "getUser"]),
    tomador() {
      return this.$store.state.tomador.tomador;
    },

    lista_cidades() {
      if (this.cidades) {
        return this.generateSelectOptions(this.cidades);
      }
    },
    lista_estados() {
      // if (!this.estados) {
      return this.generateSelectOptions(this.estados);
      // }
    },
    listaDocumentos() {
      return this.lista_documentos_necessarios.map((documento) => ({
        ...documento,
        checked: false,
      }));
    },

    lista_documentos_necessarios() {
      return [
        { id: 1, label: "CPF" },
        { id: 2, label: "Comprovante de endereço" },
        { id: 3, label: "XML" },
        { id: 4, label: "Certidões negativas" },
        { id: 5, label: "Declarações não SEFIP" },
        { id: 6, label: "Declaração simples nacional" },
        { id: 7, label: "Ficha cadastral" },
        { id: 8, label: "PGDAS" },
        { id: 9, label: "Planilha de relatório" },
        { id: 10, label: "Planilha de custos" },
        { id: 11, label: "Declaração de despesa" },
        { id: 12, label: "Declaração de INSS" },
        { id: 13, label: "Declaração de menor empregado" },
        { id: 14, label: "Solicitação de nota para empresa do cliente" },
        { id: 15, label: "Falar com local solicitando nota" },
        { id: 16, label: "Certidão negativa - Federal" },
        { id: 17, label: "Certidão negativa - Municipal" },
        { id: 18, label: "Certidão negativa - Estadual" },
        { id: 19, label: "Certidão negativa - FGTS" },
        { id: 20, label: "Certidão negativa - Trabalhista" },
        { id: 21, label: "Reter ISS" },
        { id: 22, label: "Prazo de Pagamento" },
        { id: 23, label: "Enviar arquivo de Nota Fiscal" },
        { id: 24, label: "Declarações fgts" },
      ];
    },

    lista_item() {
      return [
        { id: 1, label: "04.01 - Medicina e Biomedicina" },
        {
          id: 2,
          label:
            "04.03 - Hospitais, clínicas, laboratórios, sanatórios, manicômios, casas de saúde, prontos-socorros, ambulatórios e congêneres",
        },
      ];
    },
    mensagem_alert() {
      return this.$store.state.enf.mensagem_alert;
    },
    lista_campos() {
      return this.$store.state.configEmpresa.lista_campos;
    },
  },
  watch: {
    "form.estado_id": function () {
      this.onSelectEstado(this.form.estado_id);
    },
    "servico.valor_deducao": function () {
      this.servico.base_calculo =
        this.servico.valor_servico - this.servico.valor_deducao;
    },
    "servico.valor_servico": function () {
      if (this.servico.valor_deducao == 0) {
        this.servico.base_calculo = this.servico.valor_servico;
      } else {
        this.servico.base_calculo =
          this.servico.valor_servico - this.servico.valor_deducao;
      }
    },
  },
  methods: {
    moment,
    hasRole,
    hasPermission,

    async confirm(tipo) {
      if(this.form_espelho.socios) {
          const socioValor = this.form_espelho.socios.some((socio) => {
        return socio.valor > 0;
      });

      if (!socioValor) {
        return this.$snack.error("precisa preencher os campos de socios");
      }
      }
  
      const fileId = await this.$refs.fileInput.submit();

      if (this.lista_campos == "") {
        if (!fileId)
          return this.$snack.error("Selecione um arquivo para enviar");
        this.form_espelho.fileId = fileId;
      }

      this.form_espelho.tomadores_id = this.form.id;
      this.form_espelho.empresa_id = this.servico.id;
      this.form_espelho.email = this.servico.email;
      this.form_espelho.celular = this.servico.celular;
      this.form_espelho.simulador = parseInt(this.simulador);
      this.form_espelho.simulacao = this.tabela[this.simulador];

      this.form_espelho.fileId = fileId ? fileId : null;

      this.form_espelho.servico = {
        valor_deducao: this.servico.valor_deducao,
        valor_servico: this.servico.valor_servico,
        base_calculo: this.servico.base_calculo,
        // descricao: this.servico.descricao,
        item: this.servico.item,
        responsaveis_conta_bancaria: this.servico.responsaveis_conta_bancaria,
        contasBancarias: this.servico.contasBancarias,

        cod_tributacao: this.servico.cod_tributacao,
      };
      this.form_espelho.tomador = {
        cnpj_tomador: this.form.cpf_cnpj,
        email_notificavel: this.form.email_notificavel,
        razao_social: this.form.razao_social,
        data_competencia: this.moment(this.form.data_emissao).format(
          "YYYY-MM-01"
        ),
        data_emissao: this.form.data_emissao,
        numero_nota_fiscal: this.form.numero_nota_fiscal,
      };

      await this.$buefy.dialog.confirm({
        message: `Esta ação  ` + tipo + ` um Espelho no sistema?`,
        confirmText: "Sim",
        cancelText: "Não",
        type: "is-success",
        onConfirm: () => {
          if (tipo == "cria") this.create();
          if (tipo == "edita") this.update();
        },
      });
    },

    async create() {
      this.$store.dispatch("configEmpresa/atualizar", "");
      this.loading = true;

      await this.$store.dispatch("enf/create_enf", this.form_espelho);

      if (this.mensagem_alert.tipo != "error") {
        this.$snack.success(this.mensagem_alert.message);
        this.hidemodel();
        this.$emit("update");
      } else {
        this.$snack.error(
          "verifique se todos os dados obrigatorios forem preexidos"
        );
      }

      this.loading = false;
    },

    async update() {
      this.loading = true;
      await this.$store.dispatch("enf/update_enf", this.form_espelho);

      if (this.mensagem_alert.tipo != "error") {
        this.$snack.success(this.mensagem_alert.message);
        this.hidemodel();
        this.$emit("update");
      } else {
        this.$snack.error(
          "verifique se todos os dados obrigatorios forem preexidos"
        );
      }

      this.loading = false;
    },

    hidemodel() {
      this.$emit("hidemodel");
    },
    async fetchSocios() {
      this.loading = true;
      await empresasSociosRequest(this.getEmpresa.id)
        .then((res) => {
          this.socios = res.data.data;

          this.socios.map((item) => {
            this.contas_socio.push({
              id: item.id,
              label: item.nome_completo,
            });
          });
        })
        .catch((err) =>
          this.$snack.error(err.response.data.message || err.message)
        )
        .finally(() => (this.loading = false));
    },
    generateSelectOptions(data) {
      let options = [{ id: 0, label: "todas" }];
      for (let i = 0; i < data.length; i++) {
        options.push({ id: data[i].id, label: data[i].nome });
      }
      return options;
    },

    fetchEstados() {
      this.loading = true;
      indexEstadosRequest().then((res) => (this.estados = res.data));
    },
    onSelectEstado(id) {
      this.loading = true;
      showEstadosRequest(id)
        .then((res) => (this.cidades = res.data.cidades))
        .finally(() => (this.loading = false));
    },

    async pegarTomador() {
      await this.$store.dispatch("tomador/listar_tomador", this.form.cpf_cnpj);

      this.form = {
        id: this.tomador.id,
        razao_social: this.tomador.razao_social,
        celular: this.tomador.celular,
        email_notificavel:
          this.tomador.notificavel == "financeiro"
            ? this.tomador.email_financeiro
            : this.tomador.notificavel,
        cep: this.tomador.cep,
        endereco: this.tomador.endereco,
        numero: this.tomador.numero,
        cpf_cnpj: this.tomador.cpf_cnpj,
        complemento: this.tomador.complemento,
        cidade_id: this.tomador.cidade_id,
        estado_id: this.tomador.estado_id,
        observacao: this.tomador.observacao,
        descricao_notafiscal: this.tomador.descricao_notafiscal,

        data_competencia: new Date(),
        data_emissao: null,
        numero_nota_fiscal: null,
      };
      this.documentos_necessarios = JSON.parse(
        this.tomador.documentos_necessarios
      );
    },

    async pegarCliente() {
      let empresa = {};
      await searchEmpresasServicoRequest(this.servico.cpf_cnpj).then(
        (response) => {
          empresa = response.data.data[0];
        }
      );
      this.servico = {
        id: empresa.id,
        cpf_cnpj: empresa.cnpj,
        inscricao_municipal: empresa.inscricao_municipal,
        razao_social: empresa.razao_social,
        regime_tributario: empresa.regime_tributario,
        contasBancarias: [],
        responsaveis_conta_bancaria: [],
        cep: empresa.endereco.cep,
        endereco:
          "Rua:" +
          empresa.endereco.logradouro +
          " Bairro:" +
          empresa.endereco.bairro,
        numero: empresa.endereco.numero,
        complemento: empresa.endereco.complemento,
        dados_bacarios: null,
        cidade: empresa.endereco.cidade,
        estado: empresa.endereco.uf,
        celular: "",
        email: "",
        item: null,
        cod_tributacao: null,
        descricao: null,
        valor_servico: 0.0,
        valor_deducao: 0.0,
        base_calculo: 0.0,
      };
    },
    calcularImposto(item) {
      const valorImposto = (item.porcentagem / 100) * this.servico.base_calculo;
      return valorImposto.toFixed(2);
    },
    calcularTotalImpostos() {
      let totalImpostos = 0;
      for (const item of this.tabela[this.simulador]) {
        totalImpostos += parseFloat(this.calcularImposto(item));
      }
      return (this.servico.base_calculo - totalImpostos).toFixed(2);
    },
    voltar() {
      this.$router.push({ name: "espelho-nota-fiscal.index" });
    },

    async preenxer_campos() {
      await this.fetchEstados();
      await this.fetchSocios();

      this.fetchContasBancarias();

      if (this.lista_campos == "") {
        if (this.getEmpresa) {
          this.servico.cpf_cnpj = this.getEmpresa.cnpj;

          await this.pegarCliente();
          this.socios.map((item) => {
            this.form_espelho.socios.push({
              socio: item.nome_completo,
              valor: 0,
            });
          });
        }
      }

      if (this.lista_campos != "") {
        this.form_espelho.id = this.lista_campos.id;
        this.form_espelho.descricao = this.lista_campos.descricao;

        this.servico.cpf_cnpj = this.lista_campos.empresa.id;
        this.form_espelho.socios = this.lista_campos.socios;

        this.loading = true;
        if (this.lista_campos.tomadores_id) {
          this.form.cpf_cnpj = this.lista_campos.tomadores_id;

          await this.pegarTomador();
        } else {
          this.form.cpf_cnpj = this.lista_campos.tomador.cnpj_tomador.replace(
            /[./-]/g,
            ""
          );
          this.form.razao_social = this.lista_campos.tomador.razao_social;
          this.form.email_notificavel =
            this.lista_campos.tomador.email_notificavel;
        }

        await this.pegarCliente();
        this.servico.celular = this.lista_campos.celular;
        this.servico.email = this.lista_campos.email;
        this.simulador = this.lista_campos.simulador;

        const parsedJSON = this.lista_campos.servico;

        this.servico.item = parsedJSON.item;
        // this.servico.descricao = parsedJSON.descricao;
        this.servico.valor_servico = parsedJSON.valor_servico;
        this.servico.valor_deducao = parsedJSON.valor_deducao;
        this.servico.base_calculo = parsedJSON.base_calculo;
        this.servico.item = parsedJSON.item;
        this.servico.cod_tributacao = parsedJSON.cod_tributacao;
        this.servico.responsaveis_conta_bancaria =
          parsedJSON.responsaveis_conta_bancaria;
        this.servico.contasBancarias = parsedJSON.contasBancarias;

        const tomadorJSON = this.lista_campos.tomador;
        this.form.data_competencia = new Date(tomadorJSON.data_competencia);
        this.form.data_emissao = tomadorJSON.data_emissao;
        this.form.numero_nota_fiscal = tomadorJSON.numero_nota_fiscal;

        if (!this.hasPermission("editar local trabalho")) {
          this.admin = true;
        }
      }
      this.loading = false;
    },
    copyText(value) {
      let copi = value;
      copi = value.replace(/<p>|<\/p>/g, " ");
      this.$copyText(copi);
    },
    copyValor(value) {
      this.$copyText(value.toString().replace(".", ","));
    },
    copyDate(value) {
      let copi = null;
      var date = new Date(value);
      copi = this.moment(date).format("DD/MM/YYYY");

      this.$copyText(copi);
    },
    getContasResponsavelBancarias() {
      let cb = [];
      this.contasBancarias.map((item) => {
        if (
          this.servico.responsaveis_conta_bancaria.find(
            (rcb) => rcb == item.responsavel_cliente
          )
        ) {
          cb.push(item);
        }
      });
      this.servico.contasBancarias = cb;
    },

    fetchContasBancarias() {
      this.loading = true;
      contasBancariasRequest("empresa", this.getEmpresa.id)
        .then((res) => (this.contasBancarias = res.data))
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style >
/* Estilize a tabela */
table {
  border-collapse: collapse; /* Mescla as bordas das células */
  width: 100%; /* Largura da tabela */
}

/* Estilize as células da tabela */
table th,
table td {
  border: 1px solid #dddddd; /* Adiciona borda a todas as células */
  padding: 8px; /* Espaçamento interno das células */
  text-align: left; /* Alinhamento do texto à esquerda */
}

/* Estilize as células do cabeçalho da tabela */
table th {
  background-color: #f2f2f2; /* Cor de fundo do cabeçalho */
  font-weight: bold; /* Texto em negrito no cabeçalho */
}

/* Estilize as células da tabela (linhas pares) com fundo cinza claro */
table tr:nth-child(even) {
  background-color: #f2f2f2;
}

/* Estilize as células da tabela (linhas ímpares) com fundo branco */
table tr:nth-child(odd) {
  background-color: #ffffff;
}

/* Reduza o espaçamento vertical entre as linhas */
table tr {
  line-height: 1.5; /* Ajuste o valor conforme necessário */
}
.table-container {
  overflow-x: auto;
  width: 100%;
}

.table-scroll {
  width: 120%; /* Ajuste este valor conforme necessário */
}
</style>